import { servicesSlugs } from "@/config/constants";

// Products data for navbar
export const edTech = {
  title: "Ed-Tech & LMS",
  list: [
    {
      label: "Somriddhi",
      link: "/products/somriddhi",
      tempUrl: "https://somriddhi.com/",
    },
    {
      label: "Calibrax",
      link: "/products/calibrax",
      tempUrl: "https://calibrax.org/",
    },
    {
      label: "Courseware",
      link: "/products/courseware",
      tempUrl: "https://courseware.calibrax.org/",
    },
    {
      label: "XamPro",
      link: "/products/xampro",
      tempUrl: "https://www.xampro.org/",
    },
    {
      label: "manPowerX",
      link: "/products/manpowerx",
      tempUrl: "https://manpowerx.org/",
    },
  ],
};

export const dataTech = {
  title: "Data-Tech & Analytics",
  list: [
    {
      label: "SalesX",
      link: "/products/salesx",
      tempUrl: "https://sales-x.net/",
    },
    {
      label: "Xelerator",
      link: "/products/xelerator",
      tempUrl: "https://xelerator.org/",
    },
    {
      label: "AnalyticX",
      link: "/products/analyticx",
      tempUrl: "https://play.google.com/store/apps/details?id=com.analyticx.analyticx&hl=en",
    },
    {
      label: "HRx",
      link: "/products/hrx",
      tempUrl: "http://hrxbd.org/",
    },
    // {
    //   label: "RetailX",
    //   link: "",
    // },
  ],
};

export const quickAccess = {
  title: "Quick Access",
  list: [
    {
      label: "About Us",
      link: "/about-us",
    },
    {
      label: "Blogs",
      link: "/insights",
    },
    {
      label: "Privacy Policy",
      link: "/privacy-policy",
    },
    {
      label: "Refund Policy",
      link: "/refund-policy",
    },
    {
      label: "Our Team",
      link: "/our-team",
    },
    {
      // label: "Frequently Asked Questions",
      label: "FAQ",
      link: "/frequently-asked-questions",
    },
  ],
};

export const salesPlatforms = {
  title: "Sales & Distribution",
  list: [
    {
      label: "FieldX",
      link: "/products/fieldx",
      tempUrl: "https://field-x.org/",
    },
    {
      label: "AXS",
      link: "/products/axs",
      tempUrl: "https://axsbd.com/",
    },
    {
      label: "mERP",
      link: "/products/merp",
      tempUrl: "https://erpxbd.com/",
    },
  ],
};

export const hrmSolution = {
  title: "People-Tech",
  list: [
    {
      label: "HRx",
      link: "/products/hrx",
      tempUrl: "https://hrxbd.org/",
    },
    {
      label: "AttendX",
      link: "/products/attendx",
      tempUrl: "https://play.google.com/store/search?q=attendX&c=apps&hl=en",
    },
    {
      label: "Pathfinder",
      link: "/products/pathfinder",
      tempUrl: "https://upscalebd.com/contact",
    },
  ],
};

export const projectManage = {
  title: "Project Management",
  list: [
    {
      label: "PMX",
      link: "/products/pmx",
      tempUrl: "https://pmxbd.com/",
    },
  ],
};

export const lifeStyle = {
  title: "Lifestyle",
  list: [
    {
      label: "Elevate",
      link: "/products/elevate",
      tempUrl: "https://elevate.hrxbd.org/",
    },
    // {
    //   label: "Qurais",
    //   link: "https://qurais.com/",
    // },
    {
      label: "Eatonomy",
      link: "/products/eatonomy",
      tempUrl: "https://play.google.com/store/apps/details?id=com.Eatonomy.eatonomy&hl=en",
    },
    {
      label: "HealthcareX",
      link: "/products/healthcarex",
      tempUrl: "https://upscalebd.com/contact",
    },
  ],
};

// Services data for navbar
export const consultancy = {
  title: "Management Consulting",
  link: `/services/${servicesSlugs.managementConsulting}`,
  list: [
    {
      label: "Sales & Distribution",
      link: `/services/${servicesSlugs.managementConsulting}`,
    },
    {
      label: "Brand Management",
      link: `/services/${servicesSlugs.managementConsulting}`,
    },
    {
      label: "Strategy",
      link: `/services/${servicesSlugs.managementConsulting}`,
    },
    {
      label: "Research",
      link: `/services/${servicesSlugs.managementConsulting}`,
    },
    {
      label: "HR Consulting",
      link: `/services/${servicesSlugs.managementConsulting}`,
    },
  ],
  list2: [
    {
      label: "Platform Management",
      link: `/services/${servicesSlugs.managementConsulting}`,
    },
    {
      label: "Data Analytics",
      link: `/services/${servicesSlugs.managementConsulting}`,
    },
    {
      label: "Growth Management",
      link: `/services/${servicesSlugs.managementConsulting}`,
    },
    {
      label: "Project Management",
      link: `/services/${servicesSlugs.managementConsulting}`,
    },
  ],
};

export const humanCapitalDevelopment = {
  title: "Human Capital Development",
  link: `/services/${servicesSlugs.humanCapitalDevelopment}`,
  list: [
    {
      label: "Integrated Learning",
      link: `/services/${servicesSlugs.humanCapitalDevelopment}`,
    },
    {
      label: "Classroom Training",
      link: `/services/${servicesSlugs.humanCapitalDevelopment}`,
    },
    {
      label: "Online Training",
      link: `/services/${servicesSlugs.humanCapitalDevelopment}`,
    },
    {
      label: "Certification",
      link: `/services/${servicesSlugs.humanCapitalDevelopment}`,
    },
  ],
  list2: [
    {
      label: "People Verification",
      link: `/services/${servicesSlugs.humanCapitalDevelopment}`,
    },
    {
      label: "Talent Resourcing",
      link: `/services/${servicesSlugs.humanCapitalDevelopment}`,
    },
    {
      label: "Organizational Development",
      link: `/services/${servicesSlugs.humanCapitalDevelopment}`,
    },
    {
      label: "Employee pre-screening",
      link: `/services/${servicesSlugs.humanCapitalDevelopment}`,
    },
  ],
};

export const techServices = {
  title: "Tech Services and Consulting",
  link: `/services/${servicesSlugs.techAndServices}`,
  list: [
    {
      label: "Software Development",
      link: `/services/${servicesSlugs.techAndServices}`,
    },
    {
      label: "AI Development",
      link: `/services/${servicesSlugs.techAndServices}`,
    },
    {
      label: "Website Development",
      link: `/services/${servicesSlugs.techAndServices}`,
    },
    {
      label: "APP Development",
      link: `/services/${servicesSlugs.techAndServices}`,
    },
  ],
  list2: [
    {
      label: "LLM",
      link: `/services/${servicesSlugs.techAndServices}`,
    },
    {
      label: "AI agent development",
      link: `/services/${servicesSlugs.techAndServices}`,
    },
    {
      label: "Intelligent Cockpit",
      link: `/services/${servicesSlugs.techAndServices}`,
    },
  ],
};

export const projectManagement = {
  title: "Product Management",
  link: `/services/${servicesSlugs.productManagement}`,
  list: [
    {
      label: "Reselling",
      link: `/services/${servicesSlugs.productManagement}`,
    },
    {
      label: "Consultancy",
      link: `/services/${servicesSlugs.productManagement}`,
    },
    {
      label: "GTM consulting",
      link: `/services/${servicesSlugs.productManagement}`,
    },
    {
      label: "Performance Marketing",
      link: `/services/${servicesSlugs.productManagement}`,
    },
    {
      label: "Growth Hacking",
      link: `/services/${servicesSlugs.productManagement}`,
    },
  ],
};

export const manageServices = {
  title: "Managed Services",
  link: `/services/${servicesSlugs.manageServices}`,
  list: [
    {
      label: "Analytics",
      link: `/services/${servicesSlugs.manageServices}`,
    },
    {
      label: "IT Project Management",
      link: `/services/${servicesSlugs.manageServices}`,
    },
    {
      label: "IT Platform Management",
      link: `/services/${servicesSlugs.manageServices}`,
    },
    {
      label: "API management",
      link: `/services/${servicesSlugs.manageServices}`,
    },
  ],
};

export const creative = {
  title: "Creative & Experiential Marketing",
  link: `/services/${servicesSlugs.creative}`,
  list: [
    {
      label: "Studio",
      link: `/services/${servicesSlugs.creative}`,
    },
    {
      label: "Image Creation",
      link: `/services/${servicesSlugs.creative}`,
    },
    {
      label: "AV Creation",
      link: `/services/${servicesSlugs.creative}`,
    },
    {
      label: "Brand Comms",
      link: `/services/${servicesSlugs.creative}`,
    },
  ],
};

export const financialConsultancy = {
  title: "Financial Advisory",
  link: `/services/${servicesSlugs.financialConsultancy}`,
  list: [
    {
      label: "Auditing",
      link: `/services/${servicesSlugs.financialConsultancy}`,
    },
    {
      label: "Financial Planning & Reporting",
      link: `/services/${servicesSlugs.financialConsultancy}`,
    },
    {
      label: "TAX & VAT Consultancy",
      link: `/services/${servicesSlugs.financialConsultancy}`,
    },
  ],
};

export const services = [
  {
    label: "Management Consulting",
    link: `/services/${servicesSlugs.managementConsulting}`,
  },
  {
    label: "Human Capital Development",
    link: `/services/${servicesSlugs.humanCapitalDevelopment}`,
  },
  {
    label: "Tech Services and Consulting",
    link: `/services/${servicesSlugs.techAndServices}`,
  },
  {
    label: "Product Management",
    link: `/services/${servicesSlugs.productManagement}`,
  },
  {
    label: "Managed Services",
    link: `/services/${servicesSlugs.manageServices}`,
  },
  {
    label: "Creative and Experiential Marketing",
    link: `/services/${servicesSlugs.creative}`,
  },
  {
    label: "Creative and Experiential Marketing",
    link: `/services/${servicesSlugs.creative}`,
  },
  {
    label: "Financial Advisory",
    link: `/services/${servicesSlugs.financialConsultancy}`,
  },
];
